import { Component, Input, OnInit } from '@angular/core';
import { DynamicObjectComponent } from '@softline/dynamic';

@Component({
  selector: 'soft-dynamic-object-value',
  templateUrl: './object.component.html',
  styleUrls: ['./object.component.scss'],
  imports: [DynamicObjectComponent],
})
export class ObjectComponent implements OnInit {
  @Input() value?: any;
  @Input() definition: any;

  constructor() {}

  ngOnInit(): void {}
}
